module.exports = __webpack_public_path__ + "img/esmeralda-resort-2.e7b2508b.jpg";